import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {  useProductsContext } from "../context/ProductsProvider";
import { db } from "../lib/firebase.config";
import { doc, getDoc, deleteDoc } from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { storage } from "../lib/firebase.config";
import AddNewItem from './AddNewItem';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faEye, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import "../App.css";

<FontAwesomeIcon icon="fa-solid faPenToSquare" />

async function confirmDelete(itemId) {
    const confirmation = window.confirm(`Are you sure you want to delete item with ID ${itemId}?`);
    if (confirmation) {
      try {
        const itemDoc = doc(db, "products", itemId);
        const docSnap = await getDoc(itemDoc);
        if (docSnap.exists()) {
          const productData = docSnap.data();
          // Delete the file from Firebase Storage
          const storageRef = ref(storage, productData.path);
          await deleteObject(storageRef);
        }
        // Delete the document from Firestore
        await deleteDoc(itemDoc);
        alert(`Item with ID ${itemId} deleted successfully.`);
      } catch (error) {
        console.error(`Error deleting item with ID ${itemId}:`, error);
      }
    } else {
      console.log(`Deletion of item with ID ${itemId} canceled.`);
    }
  }

function GetAllItems() {
const { state } = useProductsContext();
const { items } = state;

const [quantities, setQuantities] = useState({}); // State to hold the quantities for each item
const [statuses, setStatuses] = useState({}); // State to hold the statuses for each item

useEffect(() => {
    const updateStatus = (quantity) => {
    return quantity < 1 ? "Sold Out" : "";
    };

    // Fetch quantities from Firebase Firestore for each item
    const fetchQuantities = async () => {
    try {
        const newQuantities = {};
        const newStatuses = {};
        for (const item of items) {
            const docRef = doc(db, "products", item.id);
            const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const productData = docSnap.data();
            if (productData && productData.quantity !== undefined) {
            newQuantities[item.id] = productData.quantity;
            newStatuses[item.id] = updateStatus(productData.quantity);
            }
        } else {
            console.log("No such document for item with ID:", item.id);
        }
        }
        setQuantities(newQuantities);
        setStatuses(newStatuses);
    } catch (error) {
        console.error("Error fetching quantities:", error);
    }
    };

    fetchQuantities();
}, [items]);

const navigate = useNavigate();
const handleOnClick = (itemId) => {
    navigate(`/product/${itemId}`, { state: { id: itemId } });
};
const handleUpdateItem = (itemId) => {
    navigate(`/update-product-form/${itemId}`, { state: { id: itemId } });
};
const handleDeleteItem = async (itemId) => {
    await confirmDelete(itemId);
};
const handleupdateImg = async (itemId) => {
    navigate(`/update-product-img/${itemId}`, { state: { id: itemId } });
};


return (
    <>
    <AddNewItem />
    <div>
    <table className="list">
        <thead>
        <tr>
            <th>Image</th>
            <th>Status</th>
            <th>Name</th>
            <th>Category</th>
            <th>Subcategory</th>
            <th>Gender</th>
            <th>Price</th>
            <th>Size</th>
            <th>Color</th>
            <th>Quantity</th>
            <th>Description</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        {items.map((item) => (
            <tr key={item.id} className="tr_list">
            <td>
                <button className="edit_img_btn" onClick={() => handleupdateImg(item.id)}>
                    <FontAwesomeIcon
                        icon={faPenToSquare}
                        style={{ width: "20px", height: "20px", padding: "2px" }}
                    />{" "} 
                </button>
                <img className="img" src={item.path} alt="Product" />
            </td>
            <td style={{color: "rgb(255, 86, 86)"}}>{statuses[item.id]}</td>
            <td>{item.title}</td>
            <td>{item.category}</td>
            <td>{item.subcategory}</td>
            <td>{item.gender}</td>
            <td>{item.price}</td>
            <td>{item.size}</td>
            <td>{item.color}</td>
            <td>{quantities[item.id]}</td>
            <td>{item.description}</td>
            <td>
                <button className="delete-btn" onClick={() => handleOnClick(item.id)}>
                <FontAwesomeIcon
                    icon={faEye}
                    style={{ width: "24px", height: "24px" }}
                />{" "} 
                </button>
            </td>
            <td>
                <button className="delete-btn" onClick={() => handleUpdateItem(item.id)}>
                <FontAwesomeIcon
                    icon={faPenToSquare}
                    style={{ width: "24px", height: "24px" }}
                />{" "} 
                </button>
            </td>
            <td>
                <button className="delete-btn" onClick={() => handleDeleteItem(item.id)}>
                <FontAwesomeIcon
                    icon={faTrashCan}
                    style={{ width: "24px", height: "24px" }}
                />{" "} 
                </button>
            </td>
            </tr>
        ))}
        </tbody>
    </table>
    </div>
    </>
);
}

export default GetAllItems;
